import { Box, Button, IconButton, Modal, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";

const LocationMessageModal = (props) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const userId = loginData?.userInformation?.UserId;

  const LanguageData = multiLanguageData?.RewardStore || {};
  const {
    TEXT_REWARD_LOCATION = English.RewardStore.TEXT_REWARD_LOCATION,
    TEXT_LOCATION_VERIFY_HEADER = English.RewardStore.TEXT_LOCATION_VERIFY_HEADER,
    TEXT_LOCATION_VERIFY_SUB_HEADER1 = English.RewardStore.TEXT_LOCATION_VERIFY_SUB_HEADER1,
    TEXT_LOCATION_VERIFY_SUB_HEADER2 = English.RewardStore.TEXT_LOCATION_VERIFY_SUB_HEADER2,
    TEXT_BACK_TO_DASHBOARD = English.RewardStore.TEXT_BACK_TO_DASHBOARD,
    TEXT_GO_TO_PROFILE = English.RewardStore.TEXT_GO_TO_PROFILE
  } = LanguageData || {};

  const navigate = useNavigate();

  const handleClose = () => {
    if (props?.onClose) {
      props.onClose();
    } else {
      navigate(`/${userId}`);
    }
  };

  const goToDashboard = () => {
    if (props?.onClose) {
      props.onClose();
    }
    navigate("/home");
  };

  const goToProfile = () => {
    if (props?.onClose) {
      props.onClose();
    }
    navigate(`/${userId}`);
  };

  return (
    <Modal open={props?.open} onClose={handleClose}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6">{TEXT_REWARD_LOCATION}</Typography>
          <Stack direction={"row"}>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>
        <Stack sx={{ alignItems: "center", textAlign: "center", mt: 1 }}>
          <Typography variant="subtitle1" sx={{ color: "error", fontWeight: 600 }}>
            {TEXT_LOCATION_VERIFY_HEADER}
          </Typography>
          <Typography variant="subtitle1">{TEXT_LOCATION_VERIFY_SUB_HEADER1}</Typography>
          <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
            {TEXT_LOCATION_VERIFY_SUB_HEADER2}
          </Typography>
        </Stack>
        <Stack direction={"row"} spacing={2} sx={{ pt: 3 }}>
          <Button variant="outlined" fullWidth onClick={goToDashboard}>
            {TEXT_BACK_TO_DASHBOARD}
          </Button>
          <Button variant="contained" fullWidth onClick={goToProfile}>
            {TEXT_GO_TO_PROFILE}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default LocationMessageModal;
